import { TERRITORIES } from 'common/constants/territories';

export interface IConfig {
  serviceName: string;
  authCheckTimeout: number;
  authClientId: string;
  getAuthHeaders: (token: string) => Partial<{ Authorization: string; }>;
  companySiteLink: string;
  authServiceName: string;
  clientSiteLink: string;
  routeStationsDistance: number;
  mapId: string;
  appStage: string;
  googleAppKey: string;
  amplitudeApiKey: string;
  territory: number;
  hereAppKey: string;
  contourA: string;
  contourB: string;
};

const {
  serviceName,
  authServiceName,
  authCheckTimeout,
  authClientId,
  clientSiteLink,
  companySiteLink,
  routeStationsDistance,
  mapId,
  appStage,
  googleAppKey,
  amplitudeApiKey,
  territory = TERRITORIES.west,
  hereAppKey,
  contourA,
  contourB
} = window.fuelStationsLocator || {};

const config: IConfig = {
  serviceName,
  authServiceName,
  authCheckTimeout,
  authClientId,
  clientSiteLink,
  companySiteLink,
  routeStationsDistance,
  mapId,
  appStage,
  googleAppKey,
  hereAppKey,
  territory,
  amplitudeApiKey,
  contourA,
  contourB,
  getAuthHeaders: (token) => (token ? { Authorization: token } : {})
};

export default config;
